import React from "react"
import Icon from "../icon"
import type { IconName } from "../icon"
import IconButtonBase from "./icon-button-base"
import type { IconButtonBaseProps } from "./icon-button-base"

export type IconButtonProps = {
  /** Icon name from the design system icon library */
  icon: IconName
} & Omit<IconButtonBaseProps, "children">

const IconButton = React.forwardRef<
  HTMLButtonElement | HTMLAnchorElement,
  IconButtonProps
>(({ icon, ...props }, ref) => {
  return (
    <IconButtonBase {...props} ref={ref}>
      <Icon name={icon} className="pointer-events-none" />
    </IconButtonBase>
  )
})

export default IconButton
